    <div class="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4 md:p-8">
      <div class="w-full max-w-md md:max-w-5xl transition-all duration-300">
        <z-card class="p-8 md:p-12 text-center space-y-8 shadow-xl border-0 bg-white rounded-3xl">
          <div class="flex justify-center mb-4">
            <div class="w-24 h-24 bg-[#1A2E47] rounded-2xl flex items-center justify-center shadow-lg">
              <img src="/logo-white.svg" alt="BAILIA" class="w-14 h-14" />
            </div>
          </div>

          <div>
            <h1 class="text-2xl md:text-3xl font-semibold text-[#1A2E47] mb-2">Bienvenue sur BAILIA</h1>
            <p class="text-sm md:text-base text-gray-600">Votre compte a été confirmé avec succès.</p>
          </div>

          <div class="bg-gray-50 rounded-2xl p-6 md:p-8 text-left space-y-4 md:space-y-0 md:grid md:grid-cols-3 md:gap-8 md:text-center">
            <h2 class="text-base md:text-lg font-medium text-[#1A2E47] mb-4 md:col-span-3 md:mb-2">
              Que pouvez-vous faire maintenant?
            </h2>

            <div class="flex items-start gap-3 md:flex-col md:items-center group">
              <div class="w-10 h-10 md:w-16 md:h-16 bg-[#1A2E47]/5 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-[#1A2E47]/10 transition-colors">
                <ng-icon name="lucideBuilding2" class="w-5 h-5 md:w-8 md:h-8 text-[#1A2E47]" />
              </div>
              <div class="flex-1">
                <h3 class="text-sm md:text-base font-medium text-[#1A2E47] mb-1">Gérer vos biens</h3>
                <p class="text-xs md:text-sm text-gray-600 leading-relaxed">
                  Suivre les travaux, les paiements et l'ensemble de vos documents en un seul endroit
                </p>
              </div>
            </div>

            <div class="flex items-start gap-3 md:flex-col md:items-center group">
              <div class="w-10 h-10 md:w-16 md:h-16 bg-[#1A2E47]/5 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-[#1A2E47]/10 transition-colors">
                <ng-icon name="lucideHeart" class="w-5 h-5 md:w-8 md:h-8 text-[#1A2E47]" />
              </div>
              <div class="flex-1">
                <h3 class="text-sm md:text-base font-medium text-[#1A2E47] mb-1">Enregistrer vos favoris</h3>
                <p class="text-xs md:text-sm text-gray-600 leading-relaxed">
                  Gardez une trace des biens qui vous intéressent pour ne jamais les perdre de vue
                </p>
              </div>
            </div>

            <div class="flex items-start gap-3 md:flex-col md:items-center group">
              <div class="w-10 h-10 md:w-16 md:h-16 bg-[#1A2E47]/5 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-[#1A2E47]/10 transition-colors">
                <ng-icon name="lucideBell" class="w-5 h-5 md:w-8 md:h-8 text-[#1A2E47]" />
              </div>
              <div class="flex-1">
                <h3 class="text-sm md:text-base font-medium text-[#1A2E47] mb-1">Recevoir des alertes</h3>
                <p class="text-xs md:text-sm text-gray-600 leading-relaxed">
                  Soyez notifié en temps réel des nouvelles propriétés disponibles sur le marché
                </p>
              </div>
            </div>
          </div>

          <div class="space-y-3 mt-6 md:max-w-md md:mx-auto">
            <button
              z-button
              type="button"
              class="w-full bg-[#00A878] hover:bg-[#008f66] h-12 text-base shadow-md rounded-xl transition-all hover:scale-[1.02]"
              (click)="router.navigate(['/auth/add-property'])"
            >
              Ajouter un Bien
            </button>

            @if (showSkip()) {
              <button
                z-button
                type="button"
                zType="outline"
                class="w-full h-12 text-base rounded-xl border-[#1A2E47] text-[#1A2E47] hover:bg-[#1A2E47]/5"
                (click)="handleSkip()"
              >
                Passer au tableau de bord
              </button>
            }
          </div>

          @if (showBack()) {
            <button
              type="button"
              class="text-sm text-[#00A878] hover:underline mt-4 font-medium"
              (click)="router.navigate(['/signup'])"
            >
              Retour à l'inscription
            </button>
          }
        </z-card>
      </div>
    </div>
